import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBasketStrainer = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 45,
	viewBox: "0 0 50.0 45.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 40.0 0.0 L 40.0 30.0 A 15.0 15.0 0.0 1 1 10.0 30.0 L 10.0 0.0 Z M 50.0 15.0 L 50.0 35.0 M 0.0 15.0 L 0.0 35.0 M 0.0 25.0 L 10.0 25.0 M 40.0 25.0 L 50.0 25.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgBasketStrainer;
